import axios from 'axios';

import { detect } from 'detect-browser';
const browser = detect();
const browserUID = (() => {
  const nav = window.navigator;
  const screen = window.screen;
  let guid = String(nav.mimeTypes.length);
  guid += nav.userAgent.replace(/\D+/g, '');
  guid += nav.plugins.length;
  guid += screen.height || '';
  guid += screen.width || '';
  guid += screen.pixelDepth || '';
  return guid;
})();
// auth http client using firebase token
const axAuth = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,

  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  data: {
    device_uid: browserUID,
    device_type: 'browser',
    device_platform: browser ? browser.os : 'unknown',
    device_os_version: (browser ? browser.name : 'unknown') + '_' + (browser ? browser.version : 'unknown'),
  },
});

export default {
  http: axAuth,

  setToken(token: string) {
    this.http.defaults.headers.Authorization = 'token ' + token;
  },

  async login(data?: object | null) {
    data = data || {};
    try {
      const res = await this.http.post('/account/login', data);
      return res.data.data;
    } catch (err) {
      throw err;
    }
  },
};
